module.exports = __webpack_public_path__ + "media/images/logo-af396c3a6073120a1cd6255b7e2117ca.png";